import { getStringFromHTMLString } from 'src/mentor/helpers/utilityFunctions'
import { ArticleLayout } from '../../tile-classes'

import { ALL_TILE_ITEM_TYPES, TILE_LAYOUT_TYPE } from 'src/consumer/constants'
import { getCorrectUsableItemType } from '../../tile-carousels-utils'

const ARTICLE_LAYOUT_TILE_LOGIC_SETTERS = {
  [getCorrectUsableItemType(ALL_TILE_ITEM_TYPES.article)]: setArticleTileItemLogic,
}

export function getArticleLayoutLogic(itemType, tileData, { navigate }) {
  const tileLogicData = new ArticleLayout({ tileData })
  const carouselMakerFunction = ARTICLE_LAYOUT_TILE_LOGIC_SETTERS?.[tileLogicData?.currentItemType]

  carouselMakerFunction &&
    carouselMakerFunction(tileLogicData, {
      navigate,
    })
  return tileLogicData
}

function setArticleTileItemLogic(tileItemLogic, { navigate }) {
  let defaultTileItemLogicWithTileData = tileItemLogic
  const currentItemType = tileItemLogic.currentItemType
  const currentTileData = tileItemLogic.tileData

  let getSecondaryItems = null
  let getSecondaryText = (item) => 'Articles'

  let onClickLogic = (item) => {
    const currentItem = item?.[currentItemType]
    navigate(
      !!currentItem?.slug ? `/article/${currentItem?.slug}` : `/article/id/${currentItem?.id}`,
    )
  }

  defaultTileItemLogicWithTileData.setTitleField((item) => {
    return item?.[currentItemType]?.title
  })
  defaultTileItemLogicWithTileData.setMainImage(
    (item) =>
      item?.[currentItemType]?.coverImage ||
      item?.[currentItemType]?.coverIcon ||
      item?.[currentItemType]?.blogBanner,
  )
  defaultTileItemLogicWithTileData.setSecondaryCardImage((item) => item?.coverIcon)
  defaultTileItemLogicWithTileData.setSecondaryTextFunction(getSecondaryText)
  defaultTileItemLogicWithTileData.setActionButtonLogic((item) => ({
    text: 'Read',
    onClick: onClickLogic,
  }))

  currentTileData?.layout === TILE_LAYOUT_TYPE.articleLayout &&
    defaultTileItemLogicWithTileData.setSecondaryTextFunction((item) =>
      getStringFromHTMLString(item?.[currentItemType]?.content),
    )

  //   if (tileObjectManipulator[defaultTileItemLogicWithTileData?.currentCategoryType]) {
  //     tileObjectManipulator?.[defaultTileItemLogicWithTileData?.currentCategoryType](
  //       defaultTileItemLogicWithTileData,
  //       { navigate },
  //     )
  //   } //// write an injector function where i dont have to write this everytime i build logic for a new itemType
}

//   const ARTICLE_LAYOUT_TILE_LOGIC_SETTER_FOR_CATEGORY_TYPE = {
//     [ALL_SUPPORTED_CATEGORY_TYPES_V2.activePlans]: setActivePlanCategoryTypeLogic,
//   } // might be useful in future
